var $ = require('js/sw-jquery/sw-jquery');

/**
 * For the element wrapping an instance of the ThreeDimensionalVisualizerComponent,
 * the data attribute is placed on a wrapping element because the 3d asset rendered may vary.
 * i.e, aopt viewer, wall thickness viewer, etc...
 *
 * Usage:
 *   data-sw-three-dimensional-viewer
 *   Container for the ThreeDimensionalVisualizerComponent
 *
 */
module.exports = function ($fragment) {

    $fragment.swFindWithSelf('[data-sw-three-dimensional-viewer]').each(function () {

        var $el = $(this);
        var modelId = $el.data('swThreeDimensionalViewer');

        require(['js/lib/models/ModelManager', 'js/lib/views/ThreeDimensionalVisualizer'], function (ModelManager, ModelEditNavigation) {
            ModelManager.amdNewModelEditModel(modelId, function (model) {
                var options = {
                    el: $el,
                    model: model
                };
                new ModelEditNavigation(options);
            });
        });

    });
};
